import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function AttendanceMonthlyPrint(body, name) {
    let bList = []
    body.forEach(element => {
        const b = [
            element.id.toString(),
            element.name,
            element.late.toString(),
            element.absent.toString(),
            element.lateDeduction.toString(),
            element.absentDeduction.toString(),
            element.totalDeduction.toString(),
            element.salary.toString(),
            element.finalSalary.toString(),


    ]

        bList = [...bList, b]
    })
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });
    const heading = ['Id', 'Name', 'Late/min', 'Absent/Days', 'Late Deduction', "Absent Deduction", 'Total Deduction', "Basic Salary", "Final Salary"];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Attendance Monthly Report", 300, 40)
    doc.text(`Date:${ToBritishDate(new Date())}`, 300, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'right'},
   //         footStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 6, cellWidth: "auto"},
 //           showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),

            columnStyles: {
                0: {halign: "left"},
                1: {halign: "left"},
                2: {halign: "center"},
                3: {halign: "center"},
                4: {halign: "center"},
                5: {halign: "center"},
                6: {halign: "right"},
                7: {halign: "right"},
                8: {halign: "right"},

            },
        }
    )
    doc.save(`Attendance-${ToBritishDate(new Date())}.pdf`);
}
export function AttendancePrint(body, name) {
    let bList = []
    body.forEach(element => {
        const b = [
            element.id.toString(),
            element.name,
            element.deduction.toString(),
            element.late.toString(),
            element.numberOfDays.toString(),
            element.salary.toString(),


        ]

        bList = [...bList, b]
    })
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });
    const heading = ['Id', 'Name', 'Deduction', 'late', 'Days Worked', "Salary"];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Attendance Report", 300, 40)
    doc.text(`Date:${ToBritishDate(new Date())}`, 300, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'right'},
            //         footStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 6, cellWidth: "auto"},
            //           showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),

            columnStyles: {
                0: {halign: "left"},
                1: {halign: "left"},
                2: {halign: "right"},
                3: {halign: "right"},
                4: {halign: "right"},
                5: {halign: "right"},


            },
        }
    )
    doc.save(`Attendance-${ToBritishDate(new Date())}.pdf`);
}

export function AttendanceReportPrint(body, name) {
    let bList = []
    const workerName = body[0].workerName
    const workerId = body[0].workerId
    body.forEach(element => {
        const b = [
            element.date,
            element.day,
            element.officeTime.toString(),
            element.arrivalTime.toString(),
            element.lateDeduction.toString(),
            element.absentDeduction.toString(),
            element.deduction.toString(),
            element.balanceSalary.toString(),
        ]

        bList = [...bList, b]
    })
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });
    const heading = ['Date', 'Day', 'Office Time', 'Arrival Time', 'Late Deduction', "Absent Deduction", 'Total Deduction', "Final Deduction"];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Attendance Report", 300, 40)
    doc.text(`Id:${workerId}`, 20, 55)
    doc.text(`Name:${workerName}`, 100, 55)

    doc.text(`Date:${ToBritishDate(new Date())}`, 300, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'right'},
            //         footStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 6, cellWidth: "auto"},
            //           showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),

            columnStyles: {
                0: {halign: "left"},
                1: {halign: "left"},
                2: {halign: "center"},
                3: {halign: "center"},
                4: {halign: "right"},
                5: {halign: "right"},
                6: {halign: "right"},
                7: {halign: "right"},


            },
        }
    )
    doc.save(`AttendanceReport-${workerName}-${ToBritishDate(new Date())}.pdf`);
}

